import { create } from "zustand";
import type { InterviewProject } from "@/api/types";

type ProjectState = {
  project: InterviewProject | null;
  displayName: string | null;
  loading: boolean;
  error: string | null;
  setProject: (project: InterviewProject, displayName: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
};

const initialState = {
  project: null,
  displayName: null,
  loading: false,
  error: null
};

export const useProjectStore = create<ProjectState>((set) => ({
  ...initialState,
  setProject: (project, displayName) => set({ project, displayName, loading: false, error: null }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  reset: () => set(initialState)
}));
